export default __webpack_public_path__ + "static/media/r7.f93870d4.jpg";